import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container, Typography } from '@mui/material';

/**
 * 404 에러 페이지 Screen 컴포넌트
 *
 * 존재하지 않는 페이지에 접근했을 때 표시되는 공용 에러 화면입니다.
 * - 404 에러 이미지와 안내 메시지
 * - 홈으로 돌아가기 버튼 제공
 * - 전체 화면 중앙 정렬 레이아웃
 *
 * @description 분석 화면명: 404_페이지_없음
 */
export default function NotFoundPage() {
  return (
    <Box
      component="main"
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        minHeight: '100vh',
      }}
    >
      <Container maxWidth="md" sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              mb: 3,
              textAlign: 'center',
            }}
          >
            <img
              alt="Under development"
              src="/assets/errors/error-404.png"
              style={{
                display: 'inline-block',
                maxWidth: '100%',
                width: 400,
              }}
            />
          </Box>
          <Typography align="center" sx={{ mb: 3 }} variant="h3">
            404: 페이지를 찾을 수 없습니다
          </Typography>
          <Typography align="center" color="text.secondary" variant="body1" sx={{ mb: 3 }}>
            접속 하신 페이지는 존재하지 않거나, 현재 접속하신 페이지가 잘못되었습니다
          </Typography>
          <Button variant="outlined" startIcon={<ArrowBackIcon />} href="/">
            홈으로 돌아가기
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
